var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 9,
  fill: "none",
  viewBox: "0 0 11 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.653.782q1.617 0 2.77 1.146 1.152 1.146 1.112 2.817l.768-.768.688.687L9.05 6.605 7.109 4.664l.687-.687.769.768q.027-1.267-.836-2.13a2.83 2.83 0 0 0-2.076-.862q-.297 0-.566.054-.27.054-.526.161l-.714-.714q.405-.216.856-.344t.95-.128M2.256 2.723l1.941 1.941-.687.687-.768-.768q-.027 1.267.835 2.13a2.83 2.83 0 0 0 2.076.862q.283 0 .56-.053a2.7 2.7 0 0 0 .532-.162l.714.714q-.405.216-.862.344a3.5 3.5 0 0 1-.944.128q-1.63 0-2.777-1.146-1.145-1.146-1.105-2.817l-.768.768-.687-.687z"
})));
export default SvgRefresh;